export const catalog_matrix = [
  //{form_key:'company_type_id', catalog_key:'company_types'},
  //{form_key:'process_id', catalog_key:'service_processes'},
  //{form_key:'responsible_id', catalog_key:'none', propname:'users'},
]